module.exports = __webpack_public_path__ + "static/media/Order-Appoint-a-Receiver-J-Kimmel-held-Jul-24-2024-ISSUED-ENTERED.c99c24bd.pdf";